import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getPowerBIReports = ({ params = {}, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/analytics-highlights/pbi-reports/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPowerBIReportEmbedToken = ({
  version = 'v1',
  powerBIReportId,
} = {}) =>
  client
    .request({
      url: `${version}/analytics-highlights/pbi-report/${powerBIReportId}/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);
